import { AccountFeatures, AppContext, Features } from "@lightspeed-invoicing/core-client/frontend";
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link, Redirect } from "react-router-dom";
import BottomPriceToggle from "../bottom-line/toggle.component";
import GlobalHelper from "../common/GlobalHelper.jsx";
import ActionButton from "../common/button/actionbutton.component.jsx";
import ConfirmButton from "../common/button/confirmbutton.component.jsx";
import SendSchedulingPageButton from '../common/button/sendSchedulingPageButton.component.jsx';
import Icon from "../common/icon/icon.component.jsx";
import AddPricingRow from "../common/pricing/addItem.component.jsx";
import ProposalPreviewModal from "../common/proposal/previewmodal.component.jsx";
import ButtonWrapper from '../common/rich-text/feature-protection-wrappers/buttonProtectionWrapper.component';
import LoadingSpinner from "../common/spinner/loading.component.jsx";
import Integrations from '../integration/Integrations.jsx';
import NewInvoiceModal from "../invoice/newmodal.component.jsx";
import ReceivePaymentModal from "../invoice/receivepaymentmodal.component.jsx";
import { getPriceListName } from "../name-helpers/priceListNameHelper";
import NewPriceListModal from "../price-list/components/NewPriceListModal";
import QuoteEventsTimeLine from "../quote/analytics/eventstimeline.component.jsx";
import AnalyticsQuoteAmounts from "../quote/analytics/quoteamounts.component.jsx";
import AnalyticsQuoteEmails from "../quote/analytics/quoteemails.component.jsx";
import AnalyticsQuoteQuestions from "../quote/analytics/quotequestions.component.jsx";
import ProjectDetailsEditForm from "../quote/project/details.component.jsx";
import { TYPE_EMAIL, TYPE_SMS } from "../state/conversation/ConversationThreadTypes";
import { FeaturePurchaseOrderTracking } from '../state/integration/IntegrationFeatureKeys';
import PriceListService from "../state/price-list/PriceListService";
import AddProducts from './AddProducts';
import NewOrderModal from './NewOrderModal.tsx';
import { CreatePOButton } from "./components";
import InternalNotes from "./internalnotes.component.jsx";
import NewExternalPurchaseOrderModal from "./newexternalpurchaseordermodal.component.jsx";

class OrderAnalytics extends Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            order: this.props.order || null,
            project: this.props.project || null,
            proposal: this.props.proposal || null,
            quoteReference: this.props.quoteReference || null,
            emails: this.props.emails || [],
            internalNotes: this.props.internalNotes || [],
            onRefresh: this.props.onRefresh || function () {
            },
            onEdit: this.props.onEdit || function () {
            },
            customFieldDefinitions: [],
            invoices: this.props.invoices || [],
            quotes: this.props.quotes || [],
            externalPurchaseOrders: this.props.externalPurchaseOrders || [],
            payments: [],
            redirect: '',
            modal: '',
            showQuestionsAndAnswers: true,
            moreLoading: false,
            statusLoading: false,
            accountLimit: null,
            isEditable: this.props.order && this.props.order.attributes.deletedAt === '',
            showModal: false,
            documentStatus: this.props.order.attributes.status || "",
        }
        this.handleRefreshOrder = this.handleRefreshOrder.bind(this)
        this.archive = this.archive.bind(this)
        this.unarchive = this.unarchive.bind(this)
        this.openPreview = this.openPreview.bind(this)
        this.exportWord = this.exportWord.bind(this)
        this.handleOnEdit = this.handleOnEdit.bind(this)
        this.printPdf = this.printPdf.bind(this)
        this.closeInvoiceCreationModal = this.closeInvoiceCreationModal.bind(this)
        this.openInvoiceCreationModal = this.openInvoiceCreationModal.bind(this)
        this.openPurchaseOrderCreationModal = this.openPurchaseOrderCreationModal.bind(this)
        this.receivePayment = this.receivePayment.bind(this)
        this.handleSendEmailModal = this.handleSendEmailModal.bind(this)
        this.handleCloseAndRefresh = this.handleCloseAndRefresh.bind(this)
        this.createPriceList = this.createPriceList.bind(this)
        this.togglePriceListModal = this.togglePriceListModal.bind(this)
        this.openEditOrderItemModal = this.openEditOrderItemModal.bind(this)
        this.handleAddOrderItemModal = this.handleAddOrderItemModal.bind(this)
        this.handleAddProductLink = this.handleAddProductLink.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
        this.duplicate = this.duplicate.bind(this)
        this.createPackingSlip = this.createPackingSlip.bind(this)
    }

    componentDidMount() {
        AppContext.getApiClient().get('/account-limits').then(res => {
            this.setState({
                accountLimit: res,
            })
        })
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            order: nextProps.order || null,
            quotes: nextProps.quotes || [],
            invoices: nextProps.invoices || [],
            externalPurchaseOrders: nextProps.externalPurchaseOrders || [],
            payments: nextProps.payments || [],
            project: nextProps.project || null,
            proposal: nextProps.proposal || null,
            quoteReference: nextProps.quoteReference || null,
            emails: nextProps.emails || [],
            isEditable: nextProps.order && nextProps.order.attributes.deletedAt === '',
            internalNotes: nextProps.internalNotes || [],
        }, () => {
            if (this.state.proposal && this.state.proposal.attributes.variables) {
                const documentInfoSection = this.state.proposal.attributes.variables.sections.find(s => s.attributes.contentType === 'document-info')
                if (documentInfoSection) {
                    this.setState({
                        showAnalyticsQuoteQuestions: !documentInfoSection.attributes.content.disableChat,
                    })
                }
            }
        })
    }

    handleRefreshOrder(orderId) {
        orderId = orderId || this.state.order.id
        this.state.onRefresh(orderId)
    }

    handleCloseAndRefresh() {
        this.setState({ modal: "" })
        this.state.onRefresh(this.state.order.id)
    }

    handleOnEdit(e) {
        e.preventDefault()
        this.state.onEdit(this.state.order.id)
    }

    archive(event) {
        event.preventDefault()
        return AppContext.getApiClient().delete('/orders/' + this.state.order.id, {}).then(q => {
            this.handleRefreshOrder()
        })
    }

    unarchive(event) {
        event.preventDefault()
        return AppContext.getApiClient().put('/orders/' + this.state.order.id + '/unarchive', {}).then(q => {
            this.setState({ editable: true })
            this.handleRefreshOrder()
        })
    }

    openPreview(event) {
        event.preventDefault()
        this.setState({
            modal: <ProposalPreviewModal
                onClose={this.handleCloseAndRefresh}
                hash={this.state.proposal.attributes.hash}
                pdfLink={this.state.proposal.attributes.variables.document.pdfUri}
                publicLink={this.state.proposal.attributes.publicLink}
                proposalType={'order'}
            />
        })
    }

    closeInvoiceCreationModal(invoiceId) {
        this.setState({
            modal: invoiceId ? <Redirect to={'/invoices/' + invoiceId + '/edit'} /> : ''
        })
    }

    openInvoiceCreationModal(event) {
        event.preventDefault()
        this.setState({
            modal: <NewInvoiceModal
                contactId={this.state.order.attributes.contactId}
                sellerId={this.state.order.attributes.sellerId}
                orderId={this.state.order.id}
                projectId={this.state.project.id}
                locationId={this.state.order.attributes.locationId}
                groups={this.state.order.attributes.groups}
                onClose={this.closeInvoiceCreationModal}
            />
        })
    }

    openPurchaseOrderCreationModal(event) {
        event.preventDefault()
        this.setState({
            modal: <NewExternalPurchaseOrderModal
                orderId={this.state.order.id}
                onClose={this.handleCloseAndRefresh}
                groups={this.state.order.attributes.groups}
            />
        })
    }

    changeStatus(statusId) {
        return function (e) {
            e.preventDefault()
            if (statusId === this.state.order.attributes.customStatusId) {
                return
            }
            this.setState({ statusLoading: true })
            AppContext.getApiClient().patch(`/orders/${this.state.order.id}`, {
                customStatusId: statusId
            }).then(o => {
                this.handleRefreshOrder()
                this.setState({ statusLoading: false })
            })
        }.bind(this)
    }

    exportWord(event) {
        event.preventDefault()
        this.setState({
            moreLoading: true,
            modal: <div className={"d-none"}>
                <iframe width={1280} height={250} src={'/p/proposals/' + this.state.proposal.attributes.hash + '/word'}
                    id={'wordFrame'} />
            </div>
        }, () => {
            setTimeout(() => {
                const header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
                    "xmlns:w='urn:schemas-microsoft-com:office:word' " +
                    "xmlns='http://www.w3.org/TR/REC-html40'>" +
                    "<head><meta charset='utf-8'><title>" + this.state.order.attributes.identifier + "</title></head><body>";
                const footer = "</body></html>";
                const iframe = document.getElementById('wordFrame');
                const innerDoc = iframe.contentDocument || iframe.contentWindow.document;
                const sourceHTML = header + innerDoc.getElementById("pdf-document").innerHTML + footer

                const source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(sourceHTML);
                const fileDownload = document.createElement("a");
                document.body.appendChild(fileDownload);
                fileDownload.href = source;
                fileDownload.download = this.state.order.attributes.identifier + '.doc';
                fileDownload.click();
                document.body.removeChild(fileDownload);
                this.setState({ moreLoading: false })
            }, 4000)
        })
    }


    openEditOrderItemModal(itemId, productId) {
        this.setState({
            modal: <AddPricingRow
                object={this.state.order}
                mainObject={'orders'}
                mainObjectItem={'order-items'}
                objectId={this.props.orderId}
                onClose={this.handleCloseModal}
                itemId={itemId}
                productId={productId}
                currency={this.props.currency}
                exchangeRate={this.props.exchangeRate}
                onItemAdd={this.handleAddOrderItemModal}
                forceBillingMethod={'one-time'}
                location={this.state.order.attributes.location}
            />
        })
    }

    handleAddProductLink(e) {
        e.preventDefault()
        this.openEditOrderItemModal()
    }

    handleAddOrderItemModal(keepOpen) {
        this.handleRefreshOrder()
        if (keepOpen) {
            return
        }
        this.setState({
            modal: ''
        })
    }

    handleCloseModal() {
        this.setState({
            modal: '',
            loading: false,
        })
    }

    handleSendEmailModal(modal) {
        this.setState({
            modal: modal
        })
    }

    printPdf(e) {
        const printUrl = this.state.proposal.attributes.printUrl
        GlobalHelper.redirectToPrintPdf(printUrl)
        this.setState({
            moreLoading: false,
        })
    }

    receivePayment(event) {
        event.preventDefault()
        this.setState({
            modal: <ReceivePaymentModal
                onClose={this.handleCloseAndRefresh}
                depositPayableObject={this.state.order}
                project={this.state.project}
                defaultAmount={parseFloat(this.state.order.attributes.depositBalance) > 0 ?
                    this.state.order.attributes.depositBalance : ''}
            />
        })
    }

    togglePriceListModal(event) {
        event?.preventDefault()
        this.setState({
            statusLoading: false,
            showModal: !this.state.showModal,
        })
    }

    createPriceList = async (title, _, creditMemoContactReceiverId) => {
        this.setState({
            statusLoading: true
        })
        const res = await PriceListService.CreatePriceListFromOrder(
            title,
            this.state.order.id,
            creditMemoContactReceiverId,
        )
        this.setState({
            statusLoading: false,
            redirect: <Redirect to={{ pathname: `/price-lists/${res.getId()}/edit` }} />
        })
    }

    renderCreatePurchaseOrderButton() {
        const purchaseOrderIntegrationKey = GlobalHelper.getFirstIntegrationKeyFoundWithEnabledFeature(FeaturePurchaseOrderTracking)
        if (!purchaseOrderIntegrationKey) {
            return <></>
        }

        let integrationLogoSrc = Integrations.getIntegrationLogoImagePath(purchaseOrderIntegrationKey, true)

        return (
            <button className="btn btn-outline-secondary mr-2 mb-2"
                onClick={this.openPurchaseOrderCreationModal}>
                <img src={integrationLogoSrc} className={'mr-1'}
                    style={{ width: '1rem' }} />
                <FormattedMessage
                    id="order.analytics.create_purchase_order_btn"
                    defaultMessage="Create Purchase Order"
                />
            </button>
        )
    }

    duplicate(event) {
        event.preventDefault()
        const fromOrderId = this.state.order.id
        const fromProjectId = this.state.project.id
        const onClose = (newOrderId) => {
            if (!newOrderId) {
                this.setState({ modal: '' })
                return
            }
            this.setState({
                redirect: <Redirect to={`/orders/${newOrderId}/edit`} />
            })
        }
        this.setState({
            modal: <NewOrderModal {...{ onClose, fromOrderId, fromProjectId }} />
        })
    }

    createPackingSlip(e) {
        e.preventDefault()
        AppContext.getApiClient().post('/proposals', {
            proposalId: this.state.proposal.id,
            contactId: this.state.order.attributes.contactId,
            type: 'packing-slip',
        }).then(res => {
            this.setState({
                modal: <Redirect to={'/proposals/' + res.attributes.hash + '/preview'} />
            })
        })
    }

    render() {
        if (!this.state.order || !this.state.proposal) {
            return <div />
        }
        const contact = this.state.order.attributes.contact
        let contactPrimaryPhoneNumber = ''
        let contactPrimaryPhoneNumberExtension = ''
        for (let i = 0; i < contact.attributes.phoneNumbers.length; i++) {
            if (contact.attributes.phoneNumbers[i]["type"] === "primary") {
                contactPrimaryPhoneNumber = contact.attributes.phoneNumbers[i]["phoneNumber"]
                contactPrimaryPhoneNumberExtension = contact.attributes.phoneNumbers[i]["extension"]
            }
        }

        return <div className={'row analytics-page py-3 mb-5'}>
            {this.state.redirect}
            {this.state.modal}
            <NewPriceListModal
                show={this.state.showModal}
                onHide={this.togglePriceListModal}
                title={this.props.order.attributes.identifier}
                objectType={'credit-memo'}
                hideSelect={true}
                onCreate={this.createPriceList}
                isLoading={this.state.statusLoading}
            />
            <div className="col-md-12 px-0">
                <div className="px-3">
                    {this.state.project &&
                        <ProjectDetailsEditForm
                            order={this.state.order}
                            proposal={this.state.proposal}
                            project={this.state.project}
                            invoices={this.state.invoices}
                            quotes={this.state.quotes}
                            externalPurchaseOrders={this.state.externalPurchaseOrders}
                            isEditable={false}
                        />}
                </div>
            </div>
            <div className="col-12 ui-module">
                <AnalyticsQuoteAmounts
                    showFullTotal={true}
                    depositPayableObject={this.state.order}
                    proposal={this.state.proposal}
                />
            </div>
            <div className={'col-12'}>
                <div className={'row'}>
                    <div className="col-12 ui-module">
                        <div className={'row'}>
                            <div className={'col-12 col-md-6 border-right'}>
                                <InternalNotes
                                    projectObject={this.state.project}
                                    onRefresh={this.handleRefreshOrder}
                                    internalNotes={this.state.internalNotes}
                                />
                            </div>
                            <div className={'col-12 col-md-6 '}>
                                {this.state.showAnalyticsQuoteQuestions && AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureSms) &&
                                    [<div className={'w-100'}>
                                        <label className="col-form-label custom-form-label pt-2 mt-1">
                                            <strong>
                                                <FormattedMessage
                                                    id="invoice.analytics.questions_and_answers_sms_label"
                                                    defaultMessage="SMS"
                                                />
                                            </strong>
                                        </label>
                                    </div>,
                                    <AnalyticsQuoteQuestions
                                        project={this.state.project}
                                        publicLink={this.state.proposal.attributes.publicLink}
                                        selectedThread={GlobalHelper.getConversationThreadIndex(this.props.project?.attributes?.conversationThreads || [], TYPE_SMS)}
                                        threadType={TYPE_SMS}
                                        onClose={this.handleCloseAndRefresh}
                                        orderId={this.state.order.id}
                                        contactFirstName={this.state.order.attributes.contact.attributes.firstName} />]
                                }
                                {this.state.showQuestionsAndAnswers &&
                                    [<div className={'w-100'}>
                                        <label className="col-form-label custom-form-label pt-2 mt-1">
                                            <strong>
                                                <FormattedMessage
                                                    id="quote.analytics.questions_and_answers_label"
                                                    defaultMessage="Questions and answers"
                                                />
                                            </strong>
                                        </label>
                                    </div>,
                                    <AnalyticsQuoteQuestions
                                        project={this.state.project}
                                        selectedThread={GlobalHelper.getConversationThreadIndex(this.props.project?.attributes?.conversationThreads || [], TYPE_EMAIL)}
                                        onClose={this.handleCloseAndRefresh}
                                        orderId={this.state.order.id}
                                        contactFirstName={this.state.order.attributes.contact.attributes.firstName} />]
                                }
                                <div className={'w-100'}>
                                    <label className="col-form-label custom-form-label pt-0">
                                        <strong>
                                            <FormattedMessage
                                                id="invoice.analytics.emails_label"
                                                defaultMessage="Emails"
                                            />
                                        </strong>
                                    </label>
                                </div>
                                <AnalyticsQuoteEmails
                                    project={this.state.project}
                                    proposal={this.state.proposal}
                                    emails={this.state.emails}
                                    onChange={this.handleRefreshOrder}
                                    isEditable={this.state.isEditable}
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div >
            <div className={'col-12'}>
                <div className="row d-flex justify-content-end">
                    <BottomPriceToggle />
                </div>
                <div className={'row'}>
                    <div className="col-12 ui-module pt-0">
                        <div className={"mb-3"}>
                            <AddProducts
                                tableId={this.state.order.attributes.pricingTableId}
                                projectId={this.state.project && this.state.project.id}
                                mainObjectItem={'order-items'}
                                groups={this.props.groups}
                                items={this.state.order.attributes.items}
                                identifierId={this.props.identifierId}
                                currency={this.props.currency}
                                identifier={this.props.identifier}
                                orderId={this.props.orderId}
                                openEditOrderItemModal={this.openEditOrderItemModal}
                                handleAddProductLink={this.handleAddProductLink}
                                addGroup={this.props.addGroup}
                                refreshOrder={this.handleRefreshOrder}
                                totalClassName={"col-xl-6 col-lg-6 col-md-12"}
                                allowEdit={this.state.order ? true : false}
                                payments={this.state.payments}
                                contactId={this.state.order.attributes.contactId}
                                showLoyalty={false}
                                depositAmount={this.state.order.attributes.depositAmount}
                                depositRatio={this.state.order.attributes.depositRatio}
                                mainObject={this.state.order.type}
                                objectId={this.state.order.id}
                                documentStatus={this.state.documentStatus}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className={'col-12 px-0'}>
                <QuoteEventsTimeLine
                    emails={this.state.emails}
                    order={this.state.order}
                    proposal={this.state.proposal}
                    project={this.state.project}
                    returns={this.state.returns}
                    isEditable={this.state.isEditable}
                    onUpdate={this.handleRefreshOrder}
                />
            </div>
            <div className="row m-0 py-1 fixed-bottom pr-0 pr-md-5 pr-xl-0">
                <div className={'col-lg-12 mx-auto col-xl-11 pt-3 pl-4 pr-4 pr-md-5 pr-xl-4'}>
                    <div className="col-12 ui-module sticky-bottom-module">
                        <div className="row justify-content-end">
                            {this.state.isEditable ?
                                <div className="col-12 d-flex justify-content-between align-content-center flex-wrap">
                                    <div className={"d-flex"}>
                                        <div>
                                            <button className={"btn btn-sm btn-outline-primary mr-2 mb-2"}
                                                onClick={this.openPreview}>
                                                <Icon value={"eye"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="invoice.analytics.preview_btn"
                                                    defaultMessage="Preview"
                                                />
                                            </button>
                                            <a className={'btn btn-sm btn-outline-primary mr-2 mb-2'}
                                                href={this.state.proposal.attributes.publicLink} target={'_blank'}>
                                                <Icon value={"external-link-alt"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="order.analytics.open_order_btn"
                                                    defaultMessage="Open order"
                                                />
                                            </a>

                                            {/* Packing Slip */}
                                            {this.state.order.attributes.packingSlipHash ? 
                                                <Link to={'/proposals/' + this.state.order.attributes.packingSlipHash + '/preview'} className={'mr-2 mb-2 btn btn-sm btn-outline-primary'}>
                                                    <Icon value={'box-open'} className={'mr-1'} />
                                                    <FormattedMessage
                                                        id="order.analytics.packing_slip_btn"
                                                        defaultMessage="Packing slip"
                                                    />
                                                </Link> :
                                                <ActionButton target={'_blank'} href={'#'} className={'btn btn-sm btn-outline-primary mr-2 mb-2'} onClick={this.createPackingSlip}>
                                                    <Icon value={'box-open'} className={'mr-1'} />
                                                    <FormattedMessage
                                                        id="order.analytics.packing_slip_btn"
                                                        defaultMessage="Packing slip"
                                                    />
                                                </ActionButton>
                                            }

                                        </div>

                                        {this.state.order.attributes.priceListReferenceId === '' &&
                                            <div>
                                                <button
                                                    className={"btn btn-sm btn-outline-primary mr-2"}
                                                    type="button"
                                                    onClick={this.togglePriceListModal}>
                                                    <Icon value={"shopping-cart"} className={"mr-1"} />
                                                    <FormattedMessage
                                                        id="order.analytics.create_price_list"
                                                        defaultMessage="Create {priceList}"
                                                        values={{
                                                            priceList: getPriceListName(this.props.intl)
                                                        }}
                                                    />
                                                </button>
                                            </div>}

                                        <div className="mr-2 mb-2 ">
                                            <button
                                                className="btn btn-sm btn-outline-primary"
                                                type="button" id="dropdownMoreButton"
                                                data-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false"
                                                disabled={this.state.moreLoading}>
                                                {!this.state.moreLoading ?
                                                    <Icon value={"ellipsis-h"} className={"mr-1"} /> : <LoadingSpinner
                                                        height={15}
                                                        width={3}
                                                        className="px-5"
                                                    />}
                                            </button>
                                            <div className="dropdown-menu" aria-labelledby="dropdownMoreButton">
                                                <a className="dropdown-item" href="#" onClick={this.duplicate}>
                                                    <Icon value={"clone"} className={"mr-1"} />
                                                    <FormattedMessage
                                                        id="quote.analytics.duplicate_btn"
                                                        defaultMessage="Duplicate"
                                                    />
                                                </a>
                                                <a className="dropdown-item" href="#" onClick={this.exportWord}>
                                                    <Icon value={"file-word"} className={"mr-1"} />
                                                    <FormattedMessage
                                                        id="quote.analytics.word_export_btn"
                                                        defaultMessage="Export to word"
                                                    />
                                                </a>
                                                <a className="dropdown-item" href="#" onClick={this.printPdf}>
                                                    <Icon value={"print"} className={"mr-1"} />
                                                    <FormattedMessage
                                                        id="quote.analytics.print_btn"
                                                        defaultMessage="Print"
                                                    />
                                                </a>
                                                <a className="dropdown-item" href="#" onClick={this.handleOnEdit}>
                                                    <Icon value={"pen"} className={"mr-1"} />
                                                    <FormattedMessage
                                                        id="quote.analytics.edit_btn"
                                                        defaultMessage="Edit"
                                                    />
                                                </a>

                                                <ConfirmButton
                                                    isLink={true}
                                                    onModalRender={(m, c) => {
                                                        this.setState({ modal: m }, c)
                                                    }}
                                                    onClick={this.archive}
                                                    identifier={this.state.order.attributes.identifier}
                                                    message={<span>
                                                        <FormattedMessage
                                                            id="order.analytics.delete_message"
                                                            defaultMessage="Are you sure you want to delete order {identifier} ?"
                                                            values={{
                                                                identifier: this.state.order.attributes.identifier
                                                            }}
                                                        />
                                                    </span>}
                                                    className="dropdown-item text-danger"
                                                >
                                                    <Icon value={"trash"} className={"mr-1"} />
                                                    <FormattedMessage
                                                        id="invoice.analytics.delete_btn"
                                                        defaultMessage="Delete"
                                                    />
                                                </ConfirmButton>
                                            </div>
                                        </div>

                                    </div>
                                    <div className={"d-flex flex-wrap"}>
                                        <div className={""}>
                                            {parseFloat(this.state.order.attributes.balance) > 0 &&
                                                !GlobalHelper.hasShopifyIntegrationWithDisabledFeatures() ?
                                                <button className="btn btn-outline-success mr-2 mb-2" onClick={this.receivePayment}>
                                                    <Icon value={"dollar-sign"} className={"mr-1"} />
                                                    <FormattedMessage
                                                        id="order.analytics.receive_payment_btn"
                                                        defaultMessage="Receive payment"
                                                    />
                                                </button> : ''}
                                        </div>
                                        <SendSchedulingPageButton
                                            typeOfDocument={"orders"}
                                            orderId={this.state.order.id}
                                            order={this.state.order}
                                            handleSendEmailModal={this.handleSendEmailModal}
                                            handleCloseModal={this.handleCloseModal}
                                        />

                                        {this.renderCreatePurchaseOrderButton()}

                                        <CreatePOButton
                                            locationId={this.state.order.attributes.location?.id}
                                            documentId={this.state.order.id}
                                            documentIdentifier={this.state.order.attributes.identifier}
                                            documentProjectId={this.state.order.attributes.projectId}
                                        />

                                        <div className=" dropup mr-2 mb-2" role="group">
                                            <button id="btnOrderStatus" type="button"
                                                className={`btn btn-outline-${GlobalHelper.getOrderStatusColor(this.state.order.attributes.customStatusId)}`}
                                                data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false"
                                                disabled={this.state.statusLoading}>
                                                {!this.state.statusLoading ? <span>
                                                    <Icon value={"edit"} className={"mr-1"} />
                                                    {GlobalHelper.getOrderStatusName(this.state.order.attributes.customStatusId)}
                                                    <Icon value={"caret-up"} className={"ml-1"} />
                                                </span> : <LoadingSpinner
                                                    height={15}
                                                    width={3}
                                                    className="px-5"
                                                />}

                                            </button>
                                            <div className="dropdown-menu" aria-labelledby="btnOrderStatus">
                                                {AppContext.getOrderStatusesByType('ordered').map(s => {
                                                    return <a key={s.id} className="dropdown-item" href="#"
                                                        onClick={this.changeStatus(s.id)}>
                                                        <span
                                                            className={'badge badge-warning'}>{s.attributes.name}</span>
                                                    </a>
                                                })}
                                                <div className="dropdown-divider" />
                                                {AppContext.getOrderStatusesByType('completed').map(s => {
                                                    return <a key={s.id} className="dropdown-item" href="#"
                                                        onClick={this.changeStatus(s.id)}>
                                                        <span
                                                            className={'badge badge-success'}>{s.attributes.name}</span>
                                                    </a>
                                                })}
                                            </div>
                                        </div>
                                        <ButtonWrapper
                                            module={Features.Invoice}
                                            message={GlobalHelper.isAccountLimitExceeded(this.state.accountLimit) ?
                                                <FormattedMessage
                                                    id="listing.search.invoice_document_limit"
                                                    defaultMessage="Documents limit exceeded."
                                                /> : ''}
                                            onClick={(e) => this.openInvoiceCreationModal(e)}
                                            redirectToAccount={!AppContext.accountFeatureIsEnabled(Features.Invoice)}
                                            className={"btn btn-success mr-2 mb-2"}
                                            protectedClassName={"btn btn-success mr-2 mb-2"}
                                            premium={false}
                                            protectionRule={AppContext.accountFeatureIsEnabled(Features.Invoice) &&
                                                (!GlobalHelper.isAccountLimitExceeded(this.state.accountLimit))}
                                        >
                                            <Icon value={"invoice"} className={"mr-1"} />
                                            <FormattedMessage
                                                id="order.analytics.create_invoice_btn"
                                                defaultMessage="Create invoice"
                                            />
                                        </ButtonWrapper>
                                    </div>
                                </div> : [<div className="col-3" key={"1"}>
                                    <ActionButton className={"btn btn-sm btn-warning mr-2 mb-2"}
                                        onClick={this.unarchive}>
                                        <FormattedMessage
                                            id="invoice.analytics.unarchive_btn"
                                            defaultMessage="Unarchive"
                                        />
                                    </ActionButton>
                                </div>,
                                <div className="col-9" key={"2"}>
                                    <p className="text-align-right text-warning m-0">
                                        <FormattedMessage
                                            id="order.analytics.archived_order_info"
                                            defaultMessage="This order is archived and can't be found in search results."
                                        />
                                    </p>
                                </div>]}
                        </div>
                    </div>
                </div>
            </div>
        </div >
    }

}

export default injectIntl(OrderAnalytics)





// WEBPACK FOOTER //
// ./src/order/analytics.component.jsx